export const AGREEMENT_LOGIN_LOADING = 'AGREEMENT_LOGIN_LOADING';
export const AGREEMENT_LOGIN_LOADED = 'AGREEMENT_LOGIN_LOADED';
export const CONNECTION_TYPE_LOADING = 'CONNECTION_TYPE_LOADING';
export const CONNECTION_TYPE_LOADED = 'CONNECTION_TYPE_LOADED';
export const AGREEMENT_LOGIN_CHANGED = 'AGREEMENT_LOGIN_CHANGED';
export const IP_PRICE_LOADING = 'IP_PRICE_LOADING';
export const IP_PRICE_LOADED = 'IP_PRICE_LOADED';
export const IP_LIST_LOADING = 'IP_LIST_LOADING';
export const IP_LIST_LOADED = 'IP_LIST_LOADED';
export const PTR_LIST_LOADING = 'PTR_LIST_LOADING';
export const PTR_LIST_LOADED = 'PTR_LIST_LOADED';
export const IPv6_STATUS_LOADING = 'IPv6_STATUS_LOADING';
export const IPv6_STATUS_LOADED = 'IPv6_STATUS_LOADED';
export const IPv6_STATUS_LOAD_ERROR = 'IPv6_STATUS_LOAD_ERROR';
export const SMTP_STATE_LOADING = 'SMTP_STATE_LOADING';
export const SMTP_STATE_LOADED = 'SMTP_STATE_LOADED';
export const SMTP_STATE_LOAD_ERROR = 'SMTP_STATE_LOAD_ERROR';
export const STATISTIC_LOADING = 'STATISTIC_LOADING';
export const STATISTIC_LOADED = 'STATISTIC_LOADED';
export const STATISTIC_ERROR = 'STATISTIC_ERROR';
export const MAC_LIST_LOADING = 'MAC_LIST_LOADING';
export const MAC_LIST_LOADED = 'MAC_LIST_LOADED';
export const MAC_LIST_ERROR = 'MAC_LIST_ERROR';
